export default class ImageZoom {
  constructor(component) {
    this.viewport = component.viewport;
    this.images = component.images;
    this.imageId = null;
    this.el = null;
    this.zoomArea = null;
    this.zoomAreaContainer = null;
    this.toggleZoomEvent = this.toggleZoom.bind(this);
    this.zoomImageEvent = this.zoomImage.bind(this);
  }

  _unbindEvents() {
    if (this.zoomAreaContainer) {
      this.zoomAreaContainer.removeEventListener('click', this.toggleZoomEvent);
    }

    if (this.zoomArea) {
      this.zoomArea.removeEventListener('mouseout', this.toggleZoomEvent);
      this.zoomArea.removeEventListener('mousemove', this.zoomImageEvent);
    }
  }

  setVariables() {
    const currentImage = this.viewport.querySelector('[data-product-gallery-selected="true"] img');
    if (!currentImage) {
      this.imageId = null;
      this.el = null;
      this.zoomArea = null;
      this.zoomAreaContainer = null;
      return;
    }

    this.imageId = currentImage.getAttribute('data-image-zoom');

    const div = document.createElement('div');

    div.innerHTML = this.images[this.imageId];
    this.el = div.firstElementChild;
    this.zoomArea = this.viewport.querySelector(`[data-product-zoom-id="${this.imageId}"]`);
    this.zoomAreaContainer = this.viewport.querySelector(`[data-media="${this.imageId}"] .product-gallery--media-wrapper`);

    this.zoomAreaContainer.addEventListener('click', this.toggleZoomEvent);
    this.zoomArea.addEventListener('mouseout', this.toggleZoomEvent);
    this.zoomArea.addEventListener('mousemove', this.zoomImageEvent);
  }

  prepareZoom(resetVariables) {
    if (resetVariables) {
      this._unbindEvents();
      this.setVariables();
    }

    if (!this.imageId) return;

    const imageSource = this.el.getAttribute('src');
    const { width: photoAreaWidth, height: photoAreaHeight } = this.zoomAreaContainer.getBoundingClientRect();

    const newImage = new Image();

    newImage.addEventListener('load', () => {
      this.zoomImageWidth = newImage.width;
      this.zoomImageHeight = newImage.height;

      const ratio = Math.max(
        this.zoomImageWidth / photoAreaWidth,
        this.zoomImageHeight / photoAreaHeight,
      );

      // Only enable the zoom if a certain zooming ratio is met.
      if (ratio < 1.4) {
        this.zoomAreaContainer.classList.remove('zoom-enabled');
      } else {
        this.zoomAreaContainer.classList.add('zoom-enabled');

        this.zoomArea.style.backgroundImage = `url(${imageSource})`;
      }
    });

    newImage.src = imageSource;
  }

  toggleZoom(e) {
    if (this.zoomAreaContainer.classList.contains('zoom-enabled')) {
      if (e.type === 'mouseout') {
        this.zoomArea.classList.remove('active');
        return;
      }

      this.zoomArea.classList.toggle('active');

      this.zoomImage(e);
    }
  }

  zoomImage(e) {
    const { width: zoomWidth, height: zoomHeight } = this.zoomArea.getBoundingClientRect();
    const { top: bigImageTop, left: bigImageLeft } = this.zoomAreaContainer.getBoundingClientRect();

    const bigImageX = Math.round(bigImageLeft);
    const bigImageY = Math.round(bigImageTop);

    const mousePositionX = e.pageX - bigImageX;
    const mousePositionY = e.pageY - bigImageY;

    // Make sure our mouse position is still inside our box.
    if ((mousePositionX < zoomWidth)
      && (mousePositionY < zoomHeight)
      && (mousePositionX > 0)
      && (mousePositionY > 0)) {
      if (this.zoomArea.classList.contains('active')) {
        // Figure out how to position the zoomed image.
        let ratioX = Math.round(((mousePositionX / zoomWidth) * this.zoomImageWidth) - (zoomWidth / 2)) * -1;
        let ratioY = Math.round(((mousePositionY / zoomHeight) * this.zoomImageHeight) - (zoomHeight / 2)) * -1;

        if (ratioX > 0) { ratioX = 0; }
        if (ratioY > 0) { ratioY = 0; }

        if (ratioX < -(this.zoomImageWidth - zoomWidth)) {
          ratioX = -(this.zoomImageWidth - zoomWidth);
        }
        if (ratioY < -(this.zoomImageHeight - zoomHeight)) {
          ratioY = -(this.zoomImageHeight - zoomHeight);
        }

        const newBackgroundPosition = `${ratioX}px ${ratioY}px`;

        this.zoomArea.style.backgroundPosition = newBackgroundPosition;
      }
    }
  }
}
